import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.css'],
})
export class SocialLinksComponent implements OnInit {
  @Input() social_networks: any = [];

  constructor() {}

  ngOnInit(): void {}

  get countryCode(): string {
    const str = this.social_networks?.countryCode;

    if (!str) {
      return '';
    }

    const result = str.match(/\d+/); // match devuelve un array con la coincidencia

    return result[0];
  }

  get facebookLink(): string {
    // debugger;
    const socialLink = this.social_networks?.facebook;

    if (socialLink.includes('https://')) {
      // console.log('soy tru');
      return socialLink;
    }
    // console.log('soy fals');

    return `https://${socialLink}`;
  }

  get instagramLink(): string {
    // debugger;
    const socialLink = this.social_networks?.instagram;

    if (socialLink.includes('https://')) {
      // console.log('soy tru');
      return socialLink;
    }
    // console.log('soy fals');

    return `https://${socialLink}`;
  }

  get tikTokLink(): string {
    // debugger;
    const socialLink = this.social_networks?.tiktok;

    if (socialLink.includes('https://')) {
      // console.log('soy tru');
      return socialLink;
    }
    // console.log('soy fals');

    return `https://${socialLink}`;
  }
}
